import { motion } from 'framer-motion';
import { useAssessmentContext } from '../../../providers/AssessmentContext';

//Images
import { ReactComponent as Spinner } from '../../../images/spinner.svg';
import { ReactComponent as Information } from '../../../images/icons/information.svg';

function CalculatingAssessment() {
    const { setAssessmentStep } = useAssessmentContext();

    setTimeout(() => {
        setAssessmentStep('result');
    }, 3000);

    return (
        <motion.div
            initial={{ opacity: 0, translateX: '20%' }}
            animate={{ opacity: 1, translateX: 0 }}
            exit={{ opacity: 0, translateX: '-20%' }}
            transition={{ ease: 'linear' }}
            className="mx-auto max-w-2xl text-center h-[calc(100vh-250px)] grid grid-col-[1fr_96px] items-center">
            <div className="flex flex-col h-full gap-y-2 justify-center">
                <div className="mx-auto p-6 w-[90px] h-[90px] rounded-2xl bg-gray-dark">
                    <Spinner className="mx-auto animate-spin" />
                </div>

                <h2 className="font-heading text-3xl text-white lg:text-8xl">Computing Risk</h2>
                <p className="text-gray-light lg:text-2xl">Taking a look at risk factors&hellip;</p>
            </div>

            <div>
                <p className="text-[#AAA5FA] flex gap-x-2 items-center justify-center">
                    <Information className="" /> Did you know?
                </p>
                <p className="text-gray">
                    Sleep apnea can cause you to stop breathing hundreds of times each night without
                    you even realizing it.
                </p>
            </div>
        </motion.div>
    );
}

export default CalculatingAssessment;
